import React, { Component } from "react";
import { css, injectGlobal } from "emotion";

import GitHub from "./GitHub";
import Twitter from "./Twitter";
import Mail from "./Mail";

const appStyle = css`
  align-items: center;
  font-family: Maven Pro, sans-serif;
  text-align: center;
  font-weight: 300;
  line-height: 1.6rem;
  margin: 0;
  padding: 0 1em;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
`;

injectGlobal`
  html, body {
    height: 100%;
  }
  body {
    background-color: #16161D;
    color: #FFFFFF;
    margin: 0;
    padding: 0 1em;
  }
  #root {
    align-items: center;
    display: flex;
    font-size: 20px;
    height: 100%;
    justify-content: center;
  }
`;

const headerStyle = css`
  font-size: 2rem;
  font-weight: inherit;
  line-height: 3.2rem;
`;

const footerStyle = css`
  margin-top: 3em;
  text-align: center;
`;

const footerItemStyle = css`
  padding: 0 20px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.3s;
`;

const aboutStyle = css`
  max-width: 400px;
`;

class App extends Component {
  render() {
    return (
      <div className={appStyle}>
        <header>
          <h1 className={headerStyle}>Darpan Kakadia</h1>
        </header>
        <main>
          <section id="about" className={aboutStyle}>
            I'm into full-stack engineering, javascript, travelling, photography
            and football.
          </section>
          <footer className={footerStyle}>
            <a
              className={footerItemStyle}
              target="_blank"
              rel="noopener noreferrer"
              href="https://twitter.com/kakadiadarpan"
            >
              <Twitter />
            </a>
            <a
              className={footerItemStyle}
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/kakadiadarpan"
            >
              <GitHub />
            </a>
            <a
              className={footerItemStyle}
              target="_blank"
              rel="noopener noreferrer"
              href="mailto:me@kakadiadarpan.com"
            >
              <Mail />
            </a>
          </footer>
        </main>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx